// The module contract (docs/spec/modules.md §2). A module is a folder here with up to four parts,
// each loaded only by the runtime that needs it, so the apps never bundle server code:
//   manifest.ts  what it is and the access it adds (every runtime)
//   worker.ts    its API routes and its part of each site's Durable Object (the Worker)
//   ui.tsx       its screens, placed into named slots (the apps)
// Modules depend on the core; the core never imports a module. Each runtime installs the
// modules it ships at startup (installModules, the worker and UI registries).
import type { ModuleEventDef, ModuleName, Permission, Role } from "@vavr/core";

export interface ModuleManifest {
  /** Lower-case id; also the namespace of its roles and permissions ("radio:use"). */
  id: string;
  name: string;
  version: string;
  description: string;
  /** Built-in modules are on for every organisation; others follow the plan or add-on (PMU-185). */
  core?: boolean;
  /** The plan or add-on that switches it on, when not core, e.g. "addon:transport". */
  entitlement?: string;
  requires?: string[];
  /** Roles the module adds, with their permissions. */
  roles?: { id: ModuleName; label: string; permissions: Permission[] }[];
  /** Module permissions granted to existing roles. */
  grants?: Record<ModuleName, Role[]>;
  /** Event types it adds to the site chain (schema v2), namespaced "<id>:<name>". */
  events?: ModuleEventDef[];
}

export const defineModule = <M extends ModuleManifest>(m: M): M => m;
